const USERS_URL = '/users'

const USERS = () => `${USERS_URL}`
const USER_BY_ID = (id: string) => `${USERS_URL}/${id}`

export default {
  USERS,
  USER_BY_ID
}
